import axios from "axios";

export const apiClient = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL || "https://chatbotapi.uvfarms.in",
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use(
  (config) => {
    // Attempt to retrieve token from localStorage
    if (typeof window !== "undefined") {
      const token = localStorage.getItem("access_token");
      if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Optional: Handle token expiration globally (e.g., clear localStorage and redirect to login)
      if (typeof window !== "undefined") {
        localStorage.removeItem("access_token");
        // We'll let the React components handle redirect via state or router.push
      }
    }
    return Promise.reject(error);
  }
);
